//UUID_TO_ASSET USER_RESULT asset_key
import polyfill from './core/polyfill';
import * as ERRORS from './core/errors';
import * as EVENTS from './core/events';
import * as API from './core/api-list';
import TEMPLATE from './core/template';
import DEBUG_POINTS from './core/debug-points';
import ImageCompress from './utils/image-compress';

import Observer from './core/observer';
import updateTryOn from './core/updater';



import * as FaceHelper from './utils/face-result-helper';
import * as MathHelper from './utils/math-helper';
import * as DomHelper from './utils/dom-helper';















import axios from 'axios';

import  {calcCenterRatio,calcPixelPosition} from './utils/face-result-helper';
import  {calculatePositionAngle,radToDegree} from './utils/math-helper';
import  {preventDefault,getElementSize,resetResourceStyle,hide,show} from './utils/dom-helper';

import md5 from "blueimp-md5";
import qs from "qs";

function XjTryOn( config ) {

	// this class should invoke with new operator v1/face/glass-2d-asset
	// if ( !  ( this instanceof XjTryOn ) ) return new XjTryOn( config );

	// dubg mode on / off
	let _debug = false;
	// let _debug = true;

	/**
	 * 事件观察者
	 * @type {Observer}
	 */
	let _Observer = new Observer();

	/**
	 * 所有模板元素缓存
	 * @type {Object}
	 */
	let _els = {};

	let _setting = {
		signature : config.signature ,
		app_id : config.app_id ,
		timestamp : config.timestamp ,
        extra : config.extra
	};

	/**
	 * Api 请求 token 前缀
	 * @type {String}
	 */
	let _token_prefix = '?_=' + config.app_id + '&t=' + config.timestamp + '&s=' + config.signature ;

	// 可能需要自定义一些初始化的参数
	if (config.extra) {
        _token_prefix += '&e=' + config.extra;
    }

	/**
	 * 初始化参数缓存
	 * @type {[type]}
	 */
	let _init_config = config;

	/**
	 * 当前试戴素材 url
	 * @type {Object}
	 */
	let _resource = {
		user_img : null ,    // config.user_img ,
		frame_img : null ,   // config.frame_img ,
		temple_img : null ,   // config.temple_img
    asset_key : null    // config.temple_img
	};

	/**
	 * 初始化参数
	 * @type {Number}
	 */
	let x = 0;
	let	y = 0;

	/**
	 * 原始标定点数据 ，可以用于重置位置
	 * @type {Object}
	 */
	let _land_mark_origin = {

		/**
		 * 当前用户图片真实尺寸
		 * @type {Object}
		 */
		user_img_actual_size : { w : 0 , h : 0} ,

		/**
		 * 头部基准像素深度，
		 * 用于眼镜空间位置根据 pose 值偏移
		 * @type {Number}
		 */
		BASE_HEAD_RADIUS : 59 ,

		/**
		 * 根据face rect与图片比例，
		 * 处理过的头部像素深度
		 * @type {Number}
		 */
		head_center_radius : 59 ,

		/**
		 * 基准透视深度
		 * @type {Number}
		 */
		BASE_PERSPECTIVE : 700 ,

		/**
		 * 调整过的透视深度
		 * @type {Number}
		 */
		perspective : 700 ,

		/**
		 * 镜框与基准瞳距缩放比
		 * @type {Number}
		 */
		BASE_PD_RATIO : 2.13 ,

		/**
		 * 调整过的缩放比
		 * @type {Number}
		 */
		pd_scale_ratio : 2.13 ,

		/**
		 * 试戴标定点像素坐标（相对当前用户面部图片大小）
		 * @type {Object}
		 */
		label_position : {

			/**
			 * 瞳距中心坐标
			 * @type {Object}
			 */
			frame_center : { x , y },

			/**
			 * 头部偏角（单位degree）
			 * @type {Object}
			 */
			pose : {

				/**
				 * 正面转角
				 * @type {Number}
				 */
				roll_angle : 0 ,

				/**
				 * 偏航角
				 * @type {Number}
				 */
				yaw_angle : 0 ,

				/**
				 * 仰角
				 * @type {Number}
				 */
				pitch_angle : 0
			}
		},

		/**
		 * 标定点比例 （百分比）
		 * @type {Object}
		 */
		ratio : {

			face_rect : 0 , // 面宽

			frame_center : { x , y } ,

			eye_center : {
				left :  { x , y } ,
				right : { x , y }
			},

			frame_joint : {
				left :  { x , y } ,
				right : { x , y }
			},

			temple_joint : {
				left :  { x , y } ,
				right : { x , y }
			},

			contour_ear : {
				left :  { x , y } ,
				right : { x , y }
			},

		}

	};

	/**
	 * 当前试戴标定点数据 for updater UUID_TO_ASSET
	 * @type {Object}
	 */
	let _land_mark = Object.assign( {} , _land_mark_origin );


	/**
	 * 接口调用者输入的调整参数
	 * @type {Object}
	 */
	let _adjust_origin = {

		frame_center : { x , y } ,

		pose : {
			roll_angle : 0 ,
			yaw_angle : 0 ,
			pitch_angle : 0
		},

		pd : {
			frame : 47 ,
			user : 47
		}

	};

	let _adjust = Object.assign( {} , _adjust_origin );

	/**
	 * 资源加载状态
	 * @type {Object}
	 */
	let _status = {
		template_inserted : false ,
		user_img_loaded : false ,
		frame_img_loaded : false ,
		left_temple_img_loaded : false ,
		right_temple_img_loaded : false
	};

	/**
	 * 后台返回的当前标定点计算数据
	 * @type {Object}
	 */
	let _result = {
		user : null ,
		frame : null ,
		temple : null
	};

	/**
	 * 绑定 资源加载状态 与 结果获取状态，
	 * 当状态改变时，不断尝试试戴
	 */
	_bindAttemptTryOn(  _status ,  _result );

	_bindTryOnEvents();

	/**
	 * 试戴素材标定点结果缓存
	 * @type {Object}
	 */
	let _cache = {

		user : {
			// user_a_img_url : user_data
			// ...
		},

		frame : {
			// frame_a_img_url : frame_data
			// ...
		},

		temple : {
			// temple_a_img_url : temple_data
			// ...
		},

    asset: {
      // uuid : {
        // frame_img : 'frame_a_img_url' ,
        // temple_img : 'temple_a_img_url'
		  // }
    }
	};

	/**
	 * 挂载试戴元素模板
	 */
	_documentReadyCall(  _initTemplate.bind( null , config.el ) );

	// 开始试戴
	tryOn( _init_config );

  /**
   * 开始试戴 / 切换试戴素材
   * @return { Object }
   * @param user_img
   * @param frame_img
   * @param temple_img
   * @param user_img_el
   * @param asset_key
   */
	function tryOn( { user_img , frame_img , temple_img , user_img_el , asset_key } ){

		if ( _debug ) console.info('[xj-init] starting try on !');

		_Observer.dispatch( EVENTS.TRYON_START );

		if ( ! _isAssetChange( { user_img , frame_img , temple_img , user_img_el, asset_key } ) ) {
			return _Observer.dispatch( EVENTS.TRYON_DONE );
		}

		if (asset_key) {
		  _resource.asset_key = asset_key;
		  _fetchAssetUseUuid(asset_key).then(asset => {
		    if (! asset) return false;

		    let resources = {
          user_img ,
          frame_img : asset.frame_img ,
          temple_img : asset.temple_img
        };
        _tryOnUseResources(user_img_el, resources);
      })
    } else {
      _tryOnUseResources(user_img_el, { user_img , frame_img , temple_img });
    }

		return public_interface;
	}

  /**
   * @param user_img_el
   * @param user_img
   * @param frame_img
   * @param temple_img
   * @private
   */

	function _tryOnUseResources(user_img_el, { user_img , frame_img , temple_img }) {
    if ( user_img_el ) {
      _readImgFromFile( user_img_el , { user_img , frame_img , temple_img } );
    } else {
      _documentReadyCall( _replaceResources.bind( null , { user_img , frame_img , temple_img } ) );
    }
  }

    /**
     * 判断试戴素材是否已更改
     * @return String
     */
	function _getTokenPrefix() {
        let _token_prefix = '?_=' + config.app_id + '&t=' + config.timestamp + '&s=' + config.signature ;

        // 可能需要自定义一些初始化的参数
        if (config.extra) {
            _token_prefix += '&e=' + config.extra;
        }

        return _token_prefix;
    }

  /**
   * 判断试戴素材是否已更改
   * @return {Boolean}
   * @param user_img
   * @param frame_img
   * @param temple_img
   * @param user_img_el
   * @param asset_key
   */
	function _isAssetChange( { user_img, frame_img, temple_img, user_img_el, asset_key } ){
		if (
			user_img_el ||
			( user_img && _resource.user_img !== user_img ) ||
			( frame_img && _resource.frame_img !== frame_img ) ||
			( temple_img && _resource.temple_img !== temple_img ) ||
			( asset_key && _resource.asset_key !== asset_key )
		) {
			return true;
		} else {
			return false;
		}
	}

	function _readImgFromFile( user_img_selector , resources_imgs ){

		let img_input = document.getElementById( user_img_selector.split('#').pop() );

		if ( ! _isImgInputValidate( img_input ) ) {
			return _Observer.dispatch( EVENTS.TRYON_ERROR , ERRORS.SELECTOR_FORMAT_ERROR );
		}

		let file_reader = new FileReader();

        file_reader.onload = function () {

        	// _els.user.src = file_reader.result;
        	let user_img_base64 = file_reader.result;

            if ( _isBase64Image( user_img_base64 ) ) {

                // resources_imgs.user_img = user_img_base64;

                ImageCompress.handle(user_img_base64, function(error, compressed_base64) {
                    if (error) _Observer.dispatch( EVENTS.TRYON_ERROR, ERRORS.IMAGE_COMPRESS_FAILED );

                    resources_imgs.user_img = compressed_base64;

                    _documentReadyCall(
                        _replaceResources.bind( null , resources_imgs )
                    );
                });

            }

        };

        file_reader.readAsDataURL( img_input.files[0] );
	}

	function _isImgInputValidate( img_input ){
		return img_input && img_input.files && img_input.files[0];
	}

	function _isBase64Image( base64_string ){
		return /data:image\/\w+;base64/.test( base64_string );
	}

	/**
	 * 重置试戴位置
	 * @return {Object}
	 */
	function reset(){
		if ( _checkConditionsAndTryOn() ) {
			_Observer.dispatch( EVENTS.RESET_START );
			_resetDefaultRatios();
			_updateUserAdjust( Object.assign( {} , _adjust_origin ) );
			_resetLandMarks();
			_resetStyleAndUpdateTryOn();
			_Observer.dispatch( EVENTS.RESET_DONE );
		}

		return public_interface
	}

	/**
	 * 重置初始化的比例
	 * @return {void}
	 */
	function _resetDefaultRatios(){
		_land_mark_origin.pd_scale_ratio = _land_mark_origin.BASE_PD_RATIO;
		_land_mark_origin.perspective = _land_mark_origin.BASE_PERSPECTIVE;
	}

    /**
     * 添加试戴事件监听
     * @return { Object }
     * @param event_name
     * @param handler
     */
	function on( event_name , handler ){
		_Observer.subscribe( event_name , handler );
		return public_interface;
	}

    /**
     * 解除监听
     * @return { Object }
     * @param event_name
     * @param handler
     */
	function off( event_name , handler ){
		_Observer.unsubcribe( event_name , handler );
		return public_interface;
	}

    /**
     * 接口调用者调整试戴参数
     * @return { Object }
     * @param user_adjust
     */
	function adjust( user_adjust ){

		if ( typeof user_adjust !== 'object' ) {
			throw new Error( ERRORS.ADJUST_TYPE_ERROR );
		}


		if ( _checkConditionsAndTryOn() ) {
			_Observer.dispatch( EVENTS.ADJUST_START );
			_resetLandMarks();
			_adjustLandMarks( _updateUserAdjust( user_adjust ) );
			_resetStyleAndUpdateTryOn();
			_Observer.dispatch( EVENTS.ADJUST_DONE );
		}

		return public_interface;
	}

    /**
     * 缓存当前用户调整参数
     * @return {Object}
     * @param frame_center
     * @param pose
     * @param pd
     */
	function _updateUserAdjust( { frame_center , pose , pd } ){
		if ( frame_center ) {
			_adjust.frame_center = frame_center;
		}
		if ( pose ) {
			_adjust.pose = pose;
		}
		if ( pd ) {
			_adjust.pd = pd;
		}

		return _adjust;
	}

    /**
     * 根据用户输入的调整参数来改变标定点参数
     * @return { void }
     * @param user_adjust
     */
	function _adjustLandMarks( user_adjust ){

		let mark_position = _land_mark.label_position;
		let origin_position = _land_mark_origin.label_position;

		Object.keys( user_adjust.frame_center || {} ).forEach(
			shift => {
				mark_position.frame_center[shift] = parseFloat( origin_position.frame_center[shift] ) + parseFloat( user_adjust.frame_center[shift] );
			}
		);

		let land_mark_pose = mark_position.pose;
		let origin_pose = origin_position.pose;
		Object.keys( user_adjust.pose || {} ).forEach(
			adjust_property => {
				land_mark_pose[adjust_property] = parseFloat( origin_pose[adjust_property] ) + parseFloat( user_adjust.pose[adjust_property]);
			}
		);

		// adjust PD
		if ( user_adjust.pd &&  user_adjust.pd.user &&  user_adjust.pd.frame ) {
			_adjustPdRatio( user_adjust.pd );
		}

		// Perspective and so on...

	}

	/**
	 * 调整瞳距与镜框中心距
	 * @param  {object}
	 * @return {void}
	 */
	function _adjustPdRatio( { frame , user } ) {
		let scale_ratio = parseFloat( frame ) / parseFloat( user );
		_land_mark.pd_scale_ratio = _land_mark_origin.pd_scale_ratio = _land_mark.BASE_PD_RATIO * scale_ratio;
	}

    /**
     * 绑定素材资源加载状态
     * @return {void}
     * @param {object} resource_load_status
     * @param {object} result_status
     */
	function _bindAttemptTryOn( resource_load_status , result_status ) {

		Object.keys( resource_load_status ).forEach( function( load_property_name ){
			Object.defineProperty( resource_load_status , load_property_name , _defineObjectAttr( load_property_name ) );
		});

		Object.keys( result_status ).forEach( function( result_property_name ){
			Object.defineProperty( result_status , result_property_name , _defineObjectAttr( result_property_name ) );
		});

	}

	function _defineObjectAttr( property ){
		const real_property = '_' + property;
		return {
			set(val) {
				this[real_property] = val; // 这个 this 是动态的
				if ( val ) {
					_attemptTryOn();
				}
			},
			get(){
				return this[real_property]; // 这个 this 是动态的
			}
		};
	}

	function _documentReadyCall( callFunc ){
		if ( document.readyState === 'complete' ) {
			callFunc();
		} else {
			window.addEventListener( 'load' , callFunc );
		}
	}

	function _initTemplate( el ){

		_els = _insertTemplate( el );

		if ( _debug ) _els = _insertDebugPonits( _els );

		let resource_elems = [
			  	_els.user     ,  _els.frame ,
			  	_els.left_temple ,  _els.right_temple
	  		];

	  	// bind load trigger try on
	  	// 图片尺寸获取一定要先绑定，然后才能 set land marks
		_els.user.addEventListener( 'load' , e => _setUserImageLandMark( e.target ) );
		_bindResourceLoadEvents( resource_elems );

	  	// prevent default drag or scroll
		resource_elems.forEach( elem => preventDefault( elem , 'dragstart') );
		resource_elems.forEach( elem => preventDefault( elem , 'touchmove') );
	}

	// 插入模板
	function _insertTemplate ( try_on_stage_selector ){

		if ( try_on_stage_selector.indexOf('#') !== 0 ){
			throw new Error( ERRORS.SELECTOR_FORMAT_ERROR )
		}

		let wrapper = document.getElementById( try_on_stage_selector.split('#').pop() );
		if ( ! wrapper) throw new Error( ERRORS.HTML_ELEMENT_NOT_FOUND );

		wrapper.innerHTML = TEMPLATE;

		_status.template_inserted = true;

		return {
			wrapper ,
			container : wrapper.getElementsByClassName('xj-tryon-container')[0] ,
			user : wrapper.getElementsByClassName('xj-u-img')[0] ,
			frame : wrapper.getElementsByClassName('xj-fr-img')[0] ,
			right_temple : wrapper.getElementsByClassName('xj-tmpl-img-r')[0] ,
			left_temple : wrapper.getElementsByClassName('xj-tmpl-img-l')[0]
		}
	}

	function _insertDebugPonits( _els ){
		_els.container.innerHTML += DEBUG_POINTS;

		// TODO delete
		let wrapper = _els.wrapper;

		return {
			wrapper ,
			container : wrapper.getElementsByClassName('xj-tryon-container')[0] ,
			user : wrapper.getElementsByClassName('xj-u-img')[0] ,
			frame : wrapper.getElementsByClassName('xj-fr-img')[0] ,
			right_temple : wrapper.getElementsByClassName('xj-tmpl-img-r')[0] ,
			left_temple : wrapper.getElementsByClassName('xj-tmpl-img-l')[0] ,
			left_eye : document.getElementById('js_debug_left_eye'),
			right_eye : document.getElementById('js_debug_right_eye')
		}
	}

	function _bindResourceLoadEvents( elements ) {

		elements.forEach( function bindTryOn( resource_element ) {
			resource_element.addEventListener( 'load' , e => _loadResourceAndTryOn( e.target ) );
			resource_element.addEventListener( 'error' , e => _errorLog(  e.target.dataset.xj ) );
		});

	}

	function _setUserImageLandMark( user_img ) {
		_land_mark_origin.user_img_actual_size = getElementSize( user_img );
	}

	function _loadResourceAndTryOn( resource_element ) {
		_loadedResource( resource_element );
		// object setting listened if resource load attemp will be trigger UUID_TO_ASSET
	}

	function _attemptTryOn(){
		if ( _checkConditionsAndTryOn() ) {
			_resetLandMarks();
			_resetStyleAndUpdateTryOn();
			_Observer.dispatch( EVENTS.TRYON_DONE );
		}
	}

	function _resetStyleAndUpdateTryOn(){
		_resetAllResourceStyles();
		updateTryOn( _els , _land_mark , _debug );
		_showAssets();
	}

	// 绑定到相关的素材元素图片上 ，当素材图片被替换时，则触发 attempt try on
	function _loadedResource( resource_element ) {
		const resource_type = resource_element.dataset.xj;
		if ( _debug ) console.info('[xj-load] ' + resource_type + ' resource load+ !');
		switch ( resource_type ) {
			case 'usr' :
				_status.user_img_loaded = true;
				break;
			case 'fr' :
				_status.frame_img_loaded = true;
				break;
			case 'lt' :
				_status.left_temple_img_loaded = true;
				break;
			case 'rt' :
				_status.right_temple_img_loaded = true;
				break;
		}
	}

	/**
	 * 检查当前资源与试戴参数是否都已准备完成
	 * @return {Boolean}
	 */
	function _checkConditionsAndTryOn(){
		return _allResourceLoaded() && _allResultLoaded();
	}

	function _allResourceLoaded(){
		return Object.keys( _status ).every( key => _status[key] );
	}

	function _allResultLoaded(){
		return Object.keys( _result ).every( key => _result[key] );
	}

	function _resetLandMarks() {
		_setFaceLandMark( _result.user );
		_setFrameLandMark( _result.frame );
		_setTempleLandMark( _result.temple );
	}

    /**
     * 替换试戴素材资源
     * @return {void}
     * @param user_img
     * @param frame_img
     * @param temple_img
     */
	function _replaceResources( { user_img , frame_img , temple_img } ) {
		_replaceUserImg( user_img );
		_replaceFrameImg( frame_img );
		_replaceTempleImg( temple_img );
	}

  /**
   *
   * @param uuid
   * @private
   */
	function _fetchAssetUseUuid(uuid) {
	   if (_cache.asset[uuid]) {
	      return Promise.resolve(_cache.asset[uuid]);
     }

	   return axios.get(API.UUID_TO_ASSET + '/' + uuid )
       // return axios.post(API.UUID_TO_ASSET + '/bd57daf4-9580-11ea-a840-00ffe96803f8')
       .then(function ( { data }) {
         if (parseInt( data.code ) === 200) {
           let asset = data.asset;
           _result.frame = _cache.frame[asset.frame_img] = asset.frame_joints;
           _result.temple = _cache.temple[asset.temple_img] = asset.temple_joints;

           _cache.asset[uuid] =  {
             frame_img : asset.frame_img,
             temple_img : asset.temple_img
           };

           return _cache.asset[uuid]
         } else {
           throw new Error( data.error );
         }
       })
       .catch(function (error) {
         _Observer.dispatch( EVENTS.TRYON_ERROR , error.message);
       });
  }

	function _replaceUserImg( user_img_url ){
		if (
			! user_img_url ||
			user_img_url === _resource.user_img
		) return;

		if ( _debug ) console.info('[xj-replace-user]');

		// unload tryon conditions
		_status.user_img_loaded = false;
		_result.user = null;

		_els.user.src = _resource.user_img = user_img_url;

		let img_cache_key = _isBase64Image( user_img_url )
			? md5( user_img_url )
			: user_img_url;

		if ( _cache.user[img_cache_key] ) {
			_result.user = _cache.user[img_cache_key];
		} else {
			_fetchUserResult( user_img_url )
				.then(function ( { data }) {
				  	if ( parseInt( data.code ) === 200 ) {
				  		let user_result = data.result.face[0];
				  		_result.user = _cache.user[img_cache_key] = user_result;
				  	} else {
				  		throw new Error( data.error );
				  	}
				})
				.catch(function (error) {
			  		_Observer.dispatch( EVENTS.TRYON_ERROR , error.message);
			  		// throw new Error( error );
				});
		}
	}

	function _fetchUserResult( user_img_url ){
		if ( _debug ) console.info('[xj-fetching-user-result] url :' + user_img_url );
		if ( _isBase64Image( user_img_url ) ) {
			return _postFetchUserResult( user_img_url );
		} else {
			return _getFetchUserResult( user_img_url );
		}
	}

	function _postFetchUserResult( user_img_url ){
        var param = {
            i : user_img_url
        };
		return axios.post( `${window.location.origin}/open/api/tryon2d/userimg`,param);
        // return axios.get( API.USER_RESULT + query_str );
	}


	function _getFetchUserResult( user_img_url ){
		// let query_str = _getTokenPrefix() + '&i='+ encodeURIComponent( encodeURI(user_img_url) );
		let query_str = '?i='+ encodeURIComponent( encodeURI(user_img_url) );
		return axios.get( API.USER_RESULT + query_str );
	}

	function _replaceFrameImg( frame_img_url ){
		if (
			! frame_img_url ||
			frame_img_url === _resource.frame_img
		) return;

		if ( _debug ) console.info('[xj-replace-frame]');

		// unload tryon conditions
		_status.frame_img_loaded = false;
		_result.frame = null;

		// reload
		_els.frame.src = _resource.frame_img = frame_img_url;
		if ( _cache.frame[frame_img_url] ) {
			_result.frame = _cache.frame[frame_img_url];
		} else {
			_fetchFrameResult( frame_img_url );
		}
	}

	function _fetchFrameResult( frame_img_url ){
		if ( _debug ) console.info('[xj-fetching-frame-result] url :' + frame_img_url );

		// let query_str = _getTokenPrefix() + '&i='+ encodeURIComponent( encodeURI(frame_img_url) );
        let query_str ='?i='+ encodeURIComponent( encodeURI(frame_img_url) );

		axios.get( API.FRAME_RESULT + query_str )
		  .then(function ( { data }) {
		  	if ( parseInt( data.code ) === 200 ) {
		  		let frame_result = data.joints;
		  		_result.frame = _cache.frame[frame_img_url] =frame_result;
		  	} else {
		  		throw new Error( data.error );
		  	}
		  })
		  .catch(function (error) {
		  		_Observer.dispatch( EVENTS.TRYON_ERROR , error.message);
		  		// throw new Error( error );
		  });

	}

	function _replaceTempleImg( temple_img_url ){
		if (
			! temple_img_url ||
			temple_img_url === _resource.temple_img
		) return;

		if ( _debug ) console.info('[xj-replace-temple]');

		// unload
		_status.left_temple_img_loaded = false;
		_status.right_temple_img_loaded = false;
		_result.temple = null;

		// reload
		_els.left_temple.src = _els.right_temple.src = _resource.temple_img = temple_img_url;
		if ( _cache.temple[temple_img_url] ) {
			_result.temple = _cache.temple[temple_img_url];
		} else {
			_fetchTempleResult( temple_img_url );
		}
	}

	function _fetchTempleResult( temple_img_url ){
		if ( _debug ) console.info('[xj-fetching-temple-result] url :' + temple_img_url );

		// let query_str = _getTokenPrefix() + '&i='+ encodeURIComponent( encodeURI(temple_img_url) );
        let query_str = '?i='+ encodeURIComponent( encodeURI(temple_img_url) );

		axios.get( API.TEMPLE_RESULT + query_str )
		  .then(function ( { data }) {
		  	if ( parseInt( data.code ) === 200 ) {
		  		let temple_result = data.joints;
		  		_result.temple = _cache.temple[temple_img_url] = temple_result;
		  	} else {
		  		throw new Error( data.error );
		  	}
		  })
		  .catch(function (error) {
		  		_Observer.dispatch( EVENTS.TRYON_ERROR , error.message );
		  		// throw new Error( error );
		  });
	}

	function _resetAllResourceStyles(){
		if ( ! Object.keys( _els ).length ) {
			return false;
		}
		resetResourceStyle( _els.frame );
		resetResourceStyle( _els.left_temple );
		resetResourceStyle( _els.right_temple );
	}

	function _errorLog( msg ){
		console.warn( msg );
	}

	// 初始化 面部标记点
    function _setFaceLandMark( face_mark ){
        _land_mark_origin.ratio.eye_center.left = face_mark.position.eye_left ;
        _land_mark_origin.ratio.eye_center.right = face_mark.position.eye_right ;
        _land_mark_origin.ratio.contour_ear.left = face_mark.position.contour_left1 ;
        _land_mark_origin.ratio.contour_ear.right = face_mark.position.contour_right1 ;

        _land_mark_origin.ratio.frame_center = FaceHelper.calcCenterRatio(
            _land_mark_origin.ratio.eye_center.left , _land_mark_origin.ratio.eye_center.right
        );

        _land_mark_origin.label_position.frame_center = FaceHelper.calcPixelPosition(
    		_land_mark_origin.user_img_actual_size , _land_mark_origin.ratio.frame_center
		);

        if ( face_mark.face_rect_width_ratio ) {
            _land_mark_origin.ratio.face_rect = face_mark.face_rect_width_ratio;
        }

        // 这里是保存原始数据坐标用来重置试戴的
        _land_mark_origin.label_position.pose.roll_angle = MathHelper.radToDegree(
	        // TODO 为什么 ratio算出来和 pixiel 差那么多？？
            // MathHelper.calculatePositionAngle( face_mark.position.eye_right , face_mark.position.eye_left  )
            MathHelper.calculatePositionAngle(
            	FaceHelper.calcPixelPosition( _land_mark_origin.user_img_actual_size , face_mark.position.eye_right ) ,
        		FaceHelper.calcPixelPosition( _land_mark_origin.user_img_actual_size , face_mark.position.eye_left )
    		)
        );
        // 这个 face++ 有时候返回的头部 roll_angle 和 真正的双目斜率不一致
        // _land_mark_origin.label_position.pose.roll_angle = face_mark.attribute.pose.roll_angle.value;
        _land_mark_origin.label_position.pose.pitch_angle = face_mark.attribute.pose.pitch_angle.value;
        _land_mark_origin.label_position.pose.yaw_angle = face_mark.attribute.pose.yaw_angle.value;

        _land_mark_origin.perspective = _land_mark_origin.BASE_PERSPECTIVE / ( face_mark.face_rect_width_ratio / 100 );

        _land_mark_origin.head_center_radius = _land_mark_origin.BASE_HEAD_RADIUS * face_mark.face_rect_width_ratio / 100;

        _land_mark = JSON.parse( JSON.stringify( _land_mark_origin ));
    }

    function _setFrameLandMark( frame_joint ){

    	_land_mark_origin.ratio.frame_joint = frame_joint;

        _land_mark = JSON.parse( JSON.stringify( _land_mark_origin ));
    }

    function _setTempleLandMark( temple_joint ){

    	_land_mark_origin.ratio.temple_joint = temple_joint;

        _land_mark = JSON.parse( JSON.stringify( _land_mark_origin ));
    }

    /**
     * @return {void} 绑定试戴过程中的事件处理
     */
    function _bindTryOnEvents(){
		_bindTryOnStartEvents();
		_bindTryOnDoneEvents();
	}

	/**
     * @return {void} 试戴开始时处理事件
     */
    function _bindTryOnStartEvents(){

    	/**
    	 * 成功后显示所有素材
    	 */
    	on( EVENTS.TRYON_START , () => _hideAssets() );
    	on( EVENTS.RESET_START , () => _hideAssets() );
    }

    /**
     * 试戴成功后处理事件
     * @return {void}
     */
    function _bindTryOnDoneEvents(){

    	/**
    	 * 成功后显示所有素材
    	 */
    	on( EVENTS.TRYON_DONE , () => _showAssets() );
    	on( EVENTS.RESET_DONE , () => _showAssets() );
    }

	/**
	 * 隐藏所有素材
	 * @return {void}
	 */
	function _hideAssets(){
		hide( _els.frame );
		hide( _els.left_temple );
		hide( _els.right_temple );
	}

    /**
     * 显示所有素材
     * @return {void}
     */
    function _showAssets(){
    	show( _els.frame );
    	show( _els.left_temple );
    	show( _els.right_temple );
    }

    let public_interface =  { tryOn , adjust , on , off , reset };

    return public_interface;
}

export {XjTryOn}
